import React from 'react'
import { RibbonOptions } from '../../../helpers/BreachWallTypes'
import { PackageOptions } from '../../BreachWallContent/BreachWallContent'
import {
    StyledRibbon,
    StyledSubscriptionInnerPriceContainer,
    StyledSubscriptionPrice,
    StyledSubscriptionPriceTextContainer,
    StyledSubscriptionSubPriceText,
} from '../SubscriptionPackageRedesign2026.styled'

type SubscriptionInnerPriceContainerProps = {
    packageOptions: PackageOptions
    price: string
    originalPrice?: string
    durationWeeks?: number
    discount?: number
    ribbonTitle?: string
    ribbonOptions?: RibbonOptions
}
export const SubscriptionInnerPriceContainer = ({
    packageOptions,
    price,
    originalPrice,
    durationWeeks = 1,
    discount,
    ribbonOptions,
    ribbonTitle,
}: SubscriptionInnerPriceContainerProps) => {
    return (
        <StyledSubscriptionInnerPriceContainer>
            <StyledSubscriptionPriceTextContainer>
                {/* If there is a discount, show the original price with a strikethrough style */}
                {discount && discount > 0 ? (
                    <>
                        <StyledSubscriptionPrice
                            packageOptions={packageOptions}
                            isDiscounted
                        >
                            {originalPrice}
                        </StyledSubscriptionPrice>
                        <StyledSubscriptionPrice
                            packageOptions={packageOptions}
                        >
                            {price}
                        </StyledSubscriptionPrice>
                        <StyledRibbon ribbonOption={'bluePillLight'}>
                            <span>Save ${discount * durationWeeks}!</span>
                        </StyledRibbon>
                    </>
                ) : (
                    // Fallback to standard layout if there is no discount
                    <>
                        <StyledSubscriptionPrice
                            packageOptions={packageOptions}
                        >
                            {price}
                        </StyledSubscriptionPrice>
                        <StyledSubscriptionSubPriceText>
                            / week
                        </StyledSubscriptionSubPriceText>
                        {/* Styled only for ribbon option blue-pill atm */}
                        {ribbonTitle && ribbonOptions === 'bluePillLight' && (
                            <StyledRibbon ribbonOption={'bluePillLight'}>
                                <span>{ribbonTitle}</span>
                            </StyledRibbon>
                        )}
                    </>
                )}
            </StyledSubscriptionPriceTextContainer>
        </StyledSubscriptionInnerPriceContainer>
    )
}
